import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  FormControl,
  InputBase,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Breadcrumbs,
  Dialog,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from "../../../components/ProgressBar";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import "./files.scss";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import FolderIcon from "@mui/icons-material/Folder";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Label from "../../../components/Label/Label";
import {
  clearApiFileUrlStatus,
  clearApiStatus,
  getFileUrl,
  getFoldersAndFiles,
} from "../../../redux/shared/actions";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const App = () => {
  const dispatch = useDispatch();

  const apiStatus = useSelector((state) => state?.shared?.apiStatus);
  const apiFileUrlStatus = useSelector(
    (state) => state.shared.apiFileUrlStatus
  );
  const foldersAndFilesList = useSelector(
    (state) => state?.shared?.foldersAndFIles
  );
  const fileUrl = useSelector((state) => state.shared.fileUrl);

  const [selectedData, setSelectedData] = useState([]);
  const [value, setValue] = useState("");
  const [openFileModal, setOpenFileModal] = useState(false);
  const [breadcrumbClickedIndex, setBreadCrumbCLickedIndex] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([
    { id: null, name: "All Files" },
  ]);
  const [tempBreadcrumbs, setTempBreadcrumbs] = useState({});
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    dispatch(getFoldersAndFiles("all"));
  }, []);

  useEffect(() => {
    if (foldersAndFilesList?.data) {
      setSelectedData(foldersAndFilesList?.data);

      if (
        foldersAndFilesList?.type &&
        foldersAndFilesList?.type === "nextById"
      ) {
        setBreadcrumbs([...breadcrumbs, tempBreadcrumbs]);
        setTempBreadcrumbs({});
      }
      if (
        foldersAndFilesList?.type &&
        foldersAndFilesList?.type === "prevById"
      ) {
        const updatedBreadcrumbs = breadcrumbs.slice(
          0,
          breadcrumbClickedIndex + 1
        );
        setBreadcrumbs(updatedBreadcrumbs);
      }
    }
  }, [foldersAndFilesList]);

  useEffect(() => {
    if (
      apiStatus?.type === "nextById" &&
      apiStatus?.apiError &&
      breadcrumbs.length > 0
    ) {
      breadcrumbs.pop();
      setBreadcrumbs(breadcrumbs);
    }
  }, [apiStatus]);

  useEffect(() => {
    if (apiFileUrlStatus && apiFileUrlStatus?.apiError) {
      setOpenFileModal(false);
    }
  }, [apiFileUrlStatus]);

  const handleClickBreadCrumb = (event, breadcrumb, index) => {
    event.preventDefault();
    if (index > 0) {
      setBreadCrumbCLickedIndex(index);
      dispatch(getFoldersAndFiles("prevById", breadcrumb?.id));
    } else {
      setBreadcrumbs([{ id: null, name: "All Files" }]);
      dispatch(getFoldersAndFiles("all"));
    }
    setSelectedData([]);
  };

  const handleFolderClick = (data, index) => {
    if (data?.object_type === "folder") {
      setTempBreadcrumbs({
        id: data?.id,
        name: data?.name,
      });
      dispatch(getFoldersAndFiles("nextById", data?.id));
      setSelectedData([]);
    }
  };

  const onChangeValue = (value) => {
    const lowercaseValue = value.toLowerCase();

    setValue(value);

    const filteredData = foldersAndFilesList?.data.filter((item) =>
      item.name.toLowerCase().startsWith(lowercaseValue)
    );

    setSelectedData(filteredData);
  };

  const clearValue = () => {
    setValue("");
    setSelectedData(foldersAndFilesList?.data);
  };

  const handleFileClick = (file) => {
    setOpenFileModal(true);
    dispatch(getFileUrl(file?.id));
  };

  const onDialogClose = () => {
    setOpenFileModal(false);
  };

  const onClickHandleClose = (type) => {
    if (type === "apiStatus") {
      dispatch(clearApiStatus());
    } else {
      dispatch(clearApiFileUrlStatus());
    }
  };

  const handleRotate = () => {
    setRotation((prev) => (prev + 90) % 360); // rotates in 90° steps
  };

  return (
    <div>
      <Grid className="files-sidebar-main" container>
        <Grid className="files-conatiner" item>
          <Grid
            container
            direction="row"
            alignItems="center"
            className="breadcrumb"
          >
            <Grid item sm={9}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs.map((breadcrumb, index) => (
                  <Link
                    underline="hover"
                    key={breadcrumb?.id}
                    color="inherit"
                    href="/"
                    onClick={(e) => handleClickBreadCrumb(e, breadcrumb, index)}
                  >
                    <Label
                      text={breadcrumb.name}
                      fontWeight="600"
                      fontSize="16px"
                    />
                  </Link>
                ))}
              </Breadcrumbs>
            </Grid>
            <Grid item md={3} className="input-wrap-container">
              <div className="search-container">
                <div className="search">
                  <div className="search-wrapper">
                    <SearchIcon />
                  </div>
                  <FormControl>
                    <InputBase
                      id="searchInput"
                      className="input-style"
                      placeholder="Folder/File Name"
                      inputProps={{ "aria-label": "search" }}
                      onChange={(event) => onChangeValue(event.target.value)}
                      value={value}
                    />
                    {value && (
                      <IconButton
                        onClick={() => clearValue()}
                        size="small"
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: 1,
                          transform: "translateY(-50%)",
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>
                </div>
              </div>
            </Grid>
          </Grid>

          <Box>
            <div>
              <List className="listContainer">
                {/* Header */}
                <ListItem className="folderListHeader">
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      sm={8}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <ListItemIcon></ListItemIcon>

                      <Label
                        text="Folder Name"
                        fontSize="14px"
                        fontWeight="500"
                      />
                    </Grid>
                    <Grid item xs={12} sm={2} textAlign={"center"}>
                      <Label
                        text="Folder Count"
                        fontSize="14px"
                        fontWeight="500"
                      />
                    </Grid>
                    <Grid item xs={12} sm={2} textAlign={"center"}>
                      <Label
                        text="File Count"
                        fontSize="14px"
                        fontWeight="500"
                      />
                    </Grid>
                  </Grid>
                </ListItem>

                {/* Rows */}
                {apiStatus?.loader ? (
                  <DashboardTableSkaleton />
                ) : foldersAndFilesList && foldersAndFilesList.isEmptyData ? (
                  <div className="no-data">
                    <Label
                      text="No Data Found"
                      fontSize="16"
                      fontWeight="600"
                      padding="20px"
                    />
                  </div>
                ) : (
                  selectedData &&
                  selectedData.length >= 0 &&
                  selectedData.map((data, index) => (
                    <ListItem
                      key={data}
                      className="folderListItem"
                      onClick={() =>
                        data?.object_type === "folder"
                          ? handleFolderClick(data, index)
                          : data?.object_type === "file" &&
                            handleFileClick(data, index)
                      }
                    >
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          {data?.object_type === "folder" ? (
                            <ListItemIcon>
                              <FolderIcon />
                            </ListItemIcon>
                          ) : (
                            <ListItemIcon>
                              <InsertDriveFileOutlinedIcon />
                            </ListItemIcon>
                          )}
                          <Label text={data?.name} />
                        </Grid>
                        {/* {data?.object_type === "folder" ? ( */}
                        <Grid item xs={12} sm={2} textAlign={"center"}>
                          <Label text={data?.dir_count || 0} />
                        </Grid>
                        {/* ) : ( */}
                        <Grid item xs={12} sm={2}>
                          <Label
                            text={data?.file_count || 0}
                            textAlign={"center"}
                          />
                        </Grid>
                        {/* )} */}
                      </Grid>
                    </ListItem>
                  ))
                )}
              </List>

              <Dialog
                fullScreen
                open={openFileModal}
                onClose={() => setOpenFileModal(false)}
              >
                <IconButton
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    marginRight: "10px",
                    marginTop: "5px",
                    zIndex: 2,
                  }}
                  edge="end"
                  color="inherit"
                  onClick={onDialogClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>

                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    position: "relative",
                    overflow: "hidden", // prevent scrollbars
                    backgroundColor: "#000", // helps contrast the rotated file
                  }}
                >
                  {apiFileUrlStatus?.loader ? (
                    <ProgressBar />
                  ) : (
                    <>
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          width: "100%",
                          height: "100%",
                          transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
                          transformOrigin: "center center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <iframe
                          src={fileUrl?.embed_url}
                          title="File Preview"
                          style={{
                            border: "none",
                            width:
                              rotation % 180 === 0 ? "100%" : "calc(100vh)",
                            height:
                              rotation % 180 === 0 ? "100%" : "calc(100vw)",
                          }}
                        />
                      </Box>

                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 50,
                          marginRight: "10px",
                          marginTop: "5px",
                          zIndex: 2,
                        }}
                        edge="end"
                        color="inherit"
                        onClick={handleRotate}
                        aria-label="rotate"
                      >
                        {/* 🔄 */}
                        <AutorenewIcon />
                      </IconButton>
                    </>
                  )}
                </Box>
              </Dialog>
            </div>
          </Box>
        </Grid>
      </Grid>

      {apiStatus?.apiError && (
        <CustomizedSnackbars
          severity="error"
          state={apiStatus?.apiError}
          text={apiStatus?.message}
          handleClose={() => onClickHandleClose("apiStatus")}
        />
      )}
      {apiFileUrlStatus?.apiError && (
        <CustomizedSnackbars
          severity="error"
          state={apiFileUrlStatus?.apiError}
          text={apiFileUrlStatus?.message}
          handleClose={() => onClickHandleClose("apiFileUrlStatus")}
        />
      )}
    </div>
  );
};

export default App;
